module.exports = __webpack_public_path__ + "img/404.4b34d077.png";